import Vue from 'vue';
import Component from 'vue-class-component';
import { ITableColumn } from '@/entity/table/table.types';

@Component
export class SalaryCalculationsTable extends Vue {

    get columnsSettlement(): ITableColumn[] {
        return [
            {
                title: 'Дата',
                dataIndex: 'key0',
                key: '0',
                scopedSlots: {
                    customRender: 'date_action'
                }
            },
            {
                title: 'Назначение',
                dataIndex: 'key1',
                key: '1',
            },
            {
                title: 'Приход, ₽',
                dataIndex: 'key2',
                key: '2',
            },
            {
                title: 'Расход, ₽',
                dataIndex: 'key3',
                key: '3',
            },
            {
                title: 'Баланс, ₽',
                dataIndex: 'key4',
                key: '4',
            },
        ]
    }

    get columnsCard(): ITableColumn[] {
        return [
            {
                title: 'Дата',
                dataIndex: 'key0',
                key: '0',
            },
            {
                title: 'Статья',
                dataIndex: 'key1',
                key: '1',
            },
            {
                title: 'Товар/Услуга',
                dataIndex: 'key2',
                key: '2',
            },
            {
                title: 'Правила расчета',
                dataIndex: 'key3',
                key: '3',
            },
            {
                title: 'Стоимость, ₽',
                dataIndex: 'key4',
                key: '4',
            },
            {
                title: 'Себестоимость, ₽',
                dataIndex: 'key5',
                key: '5',
            },
            {
                title: 'Сумма, ₽',
                dataIndex: 'key6',
                key: '6',
            },
        ]
    }

    get columnsSettlementPerDay(): ITableColumn[] {
        return [
            {
                title: 'Время',
                dataIndex: 'key0',
                key: '0',
                scopedSlots: {
                    customRender: 'date_action'
                }
            },
            {
                title: 'Мария',
                dataIndex: 'key1',
                key: '1',
            },
            {
                title: 'Ирина',
                dataIndex: 'key2',
                key: '2',
            },
            {
                title: 'Елена',
                dataIndex: 'key3',
                key: '3',
            },
            {
                title: 'Алена',
                dataIndex: 'key4',
                key: '4',
            },
        ]
    }

    get columnsSettlementPerPeriod(): ITableColumn[] {
        return [
            {
                title: '',
                dataIndex: 'key0',
                key: '0',
                scopedSlots: {
                    customRender: 'avatar'
                }
            },
            {
                title: 'Сотрудник',
                dataIndex: 'key1',
                key: '1',
            },
            {
                title: 'Рабочее время',
                dataIndex: 'key2',
                key: '2',
            },
            {
                title: 'Оказано услуг',
                dataIndex: 'key3',
                key: '3',
            },
            {
                title: 'Стоимость услуг, ₽',
                dataIndex: 'key4',
                key: '4',
            },
            {
                title: 'Продаж товаров',
                dataIndex: 'key5',
                key: '5',
            },
            {
                title: 'Стоимость товаров, ₽',
                dataIndex: 'key6',
                key: '6',
            },
            {
                title: 'Суммарная стоимость, ₽',
                dataIndex: 'key7',
                key: '7',
            },
            {
                title: 'Зарплата, ₽',
                dataIndex: 'key8',
                key: '8',
            },
            {
                title: 'Взаиморасчеты',
                dataIndex: 'key9',
                key: '9',
                scopedSlots: {
                    customRender: 'settlements'
                }
            },
        ]
    }

    get columnsPayrollRule(): ITableColumn[] {
        return [
            {
                title: 'Название',
                dataIndex: 'key0',
                key: '0',
            },
            {
                title: 'За услуги',
                dataIndex: 'key1',
                key: '1',
            },
            {
                title: 'За товары',
                dataIndex: 'key2',
                key: '2',
            },
            {
                title: 'Оклад',
                dataIndex: 'key3',
                key: '3',
            },
            {
                title: '',
                dataIndex: 'key4',
                key: '4',
                scopedSlots: {
                    customRender: 'edit'
                }
            },
            {
                title: '',
                dataIndex: 'key5',
                key: '5',
                scopedSlots: {
                    customRender: 'delete'
                }
            },
        ]
    }

    get columnsСalculationСriteria(): ITableColumn[] {
        return [
            {
                title: 'Название',
                dataIndex: 'key0',
                key: '0',
            },
            {
                title: 'Период',
                dataIndex: 'key1',
                key: '1',
            },
            {
                title: 'Условия',
                dataIndex: 'key2',
                key: '2',
            },
            {
                title: '',
                dataIndex: 'key4',
                key: '3',
                scopedSlots: {
                    customRender: 'edit'
                }
            },
            {
                title: '',
                dataIndex: 'key5',
                key: '4',
                scopedSlots: {
                    customRender: 'delete'
                }
            },
        ]
    }

    get columnsCreateCriteria(): ITableColumn[] {
        return [
            {
                title: 'Что',
                dataIndex: 'key0',
                key: '0',
            },
            {
                title: 'Для кого',
                dataIndex: 'key1',
                key: '1',
            },
            {
                title: 'За что',
                dataIndex: 'key2',
                key: '2',
            },
            {
                title: 'Превышает',
                dataIndex: 'key4',
                key: '3',
            },
            {
                title: 'С учетом скидок',
                dataIndex: 'key5',
                key: '4',
            },
        ]
    }

}